import $axios from "@/helpers/axios-helper";
import { service_paths } from "@/constants/Services";
import { getId } from "@/helpers/utils";
import debounce from "lodash/debounce";
import { API_RECIPIENT, LIST_RECIPIENT } from "./index.js";

const dataRecipient = {
  data() {
    return {
      optionSelected: {
        classList: [],
        termList: [],
        gradeList: [],
        programList: [],
        studentList: [],
        parentList: [],
        teacherList: [],
        roleList: []
      }
    };
  },
  methods: {
    debounceSearchKey: debounce(function(event, params, url) {
      const responseData = $axios.get(
        `${url}`,
        params,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      if (this.recSetting === "other_staffs") {
        this.fetchRoleOpts(responseData);
      }
      eval(API_RECIPIENT[this.recipientFilter.filter]);
    }, 400),
    getOptionList: function(typeList, data, displayField) {
      let displayName = [];
      let optionList = data
        .filter(type => {
          return !this.optionSelected[typeList]
            .map(item => item.id)
            .includes(type.id);
        })
        .map(type => {
          if (displayField) {
            displayName = displayField.map(field => {
              return `${type[field]}`;
            });
          }
          return {
            id: getId(type),
            name:
              type.name ||
              displayName.filter(item => item !== "null").join(" - ")
          };
        });
      this.optionRecSelected = [
        ...this.optionSelected[typeList],
        ...optionList
      ];
    },
    fetchClassOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("classList", response.data.data);
      }
    },
    fetchTermOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("termList", response.data.data);
      }
    },
    fetchGradeOpts: async function(responseData) {
      const response = await responseData;
      this.getOptionList("gradeList", response.data.data);
    },
    fetchProgramOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("programList", response.data.data);
      }
    },
    fetchStudentOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("studentList", response.data.data, [
          "full_name",
          "student_code"
        ]);
      }
    },
    fetchFamilyOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("parentList", response.data.data, [
          "full_name",
          "username"
        ]);
      }
    },
    fetchTeacherOpts: async function(responseData) {
      const response = await responseData;
      if (response.data.data.length) {
        this.getOptionList("teacherList", response.data.data, [
          "full_name",
          "staff_code"
        ]);
      }
    },
    fetchRoleOpts: async function(responseData) {
      const response = await responseData;
      this.recipientFilter.filter_id.length = 0;
      if (response.data.length) {
        const roleList = response.data.filter(role => role.name !== "Teacher");
        this.getOptionList("roleList", roleList);
        this.recipientFilter.filter_id = this.optionRecSelected.map(
          item => item.id
        );
      }
    }
  }
};

export { dataRecipient };
